import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';

interface LinesEquipmentState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;

    prefereds: any;
    relatedEquipmentList: any[];
    schema: any;
    meta: any;

    targetForDelete: any[];
    remains: any[];
}

const state: LinesEquipmentState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,

    prefereds: [],
    relatedEquipmentList: [],

    targetForDelete: [],
    remains: [],
    schema: {},
    meta: {},
};

const initState: any = cloneDeep(state);

const LINES_EQUIPMENT_LIST = 'LINES_EQUIPMENT_LIST';
const LINES_EQUIPMENT_SCHEMA = 'LINES_EQUIPMENT_SCHEMA';

function getBasketItem(state: LinesEquipmentState, saved: any) {
  console.log('saved', saved)
  if (saved) {
    return {
      id: saved.id,
      text: saved.text,
      with_button: saved.with_button,
      button_label: saved.button_label,
      field_id: saved.field_id,
      type: saved.type,
      action: saved.action,
    };
  } else {
    console.log('state.prefereds', state.prefereds)

    return {
      id: Math.random(),
      text: null,
      with_button: null,
      button_label: null,
      field_id: null,
      type: 'tare',
      action: 'none',
    }
  }

}

export const actions: ActionTree<LinesEquipmentState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId, remains }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;
        state.clientId = clientId;
        state.remains = remains;

        return new Promise((resolve, reject) => {
          vm.$db([
            vm.$q(LINES_EQUIPMENT_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'vle.id',
                  equipment_id: 'vle.equipment_id',
                },
                from: 's:voc_lines_equipments',
                from_as: 'vle',
                joins: [
                ],
                order: [
                  {$asc: ['vle.id']}
                ],
                where: {
                  $eq: [`vle.line_id`, {$: documentId}]
                }
              }),
              vm.$q(LINES_EQUIPMENT_SCHEMA)
                  .raw('schemas.get')
                  .action({
                      id: `s:voc_lines_equipments`
                  }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(LINES_EQUIPMENT_LIST);
            if (!opRelResult.hasError()) {
              commit('SET_DATA', {
                data: opRelResult.getContent().documents,
                schema: result.getOperation(LINES_EQUIPMENT_SCHEMA).getContent().schema
              })
            }

            resolve(null);
          });
        })
    },

    addItem({ state }) {
      state.relatedEquipmentList.push(
        {
          line_id: state.documentId,
          equipment_id: null
        }
      )
    },

    removeItem({ state }, index: number) {
        if (state.relatedEquipmentList[index].id) {
            state.targetForDelete.push(state.relatedEquipmentList[index].id)
        }

        state.relatedEquipmentList.splice(index, 1);
    },

    changeFormValue({ state }, { index, field, newValue}) {
      state.relatedEquipmentList[index][field] = newValue;
    },

    saveForm({ state, dispatch }) {
      const vm = (this as any)._vm;
      const allowedFields = ['id', 'line_id', 'equipment_id'];

      return new Promise((resolve, reject) => {
        const normalizedItemsData = state.relatedEquipmentList.map((item, index) => {
          console.log('n => ', item);
          const cleanDocuemnt: any = Object.keys(item)
          .filter((key: string) => allowedFields.includes(key))
          .reduce((obj: any, key: string) => {
              console.log('key => ', key, obj);
              if (key == 'id') {
                console.log('d1 => ', item[key]);
                item[key] = (typeof(item[key]) == 'string') ? item[key] : null;
                console.log('d2 => ', item[key]);
              }
              obj[key] = item[key];
              return obj;
            }, {});

          console.log('d => ', cleanDocuemnt);
          return cleanDocuemnt;
        });

        const queries = [
          vm.$q(`SAVE_DEAL_BASKET`)
            .update(state.documentId, {})
            .createManyRelation('voc_lines_equipments', 'line_id', (createRelated: any) => {
              return normalizedItemsData.filter((item: any) => !item.id || (typeof(item.id) !== 'string')).map((item, index) => createRelated(item));
            })
            .updateManyRelation('voc_lines_equipments', 'line_id', (updateRelated: any) => {
              return normalizedItemsData.filter((item: any) => (typeof(item.id) == 'string')).map((item, index) => updateRelated(item))
            })
            .deleteManyRelation('voc_lines_equipments', 'line_id', (deleteRelated: any) => {
              return state.targetForDelete.map((item: any, index) => deleteRelated({ id: item }));
            })
        ]

        vm.$db(queries)
          .then((result: ServerResult) => {
            const totalSaveRes = !result.getOperation(`SAVE_DEAL_BASKET`).hasError();
            if (totalSaveRes) {
              state.targetForDelete = [];

              dispatch('loadData', { documentId: state.documentId})
                .then(() => {
                  resolve();
                })
            } else {
              reject();
            }
          });
      })
    },
};

export const mutations: MutationTree<LinesEquipmentState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  SET_DATA: (state, {data, schema}) => {
    state.relatedEquipmentList = data
    state.schema = schema
    state.meta = fetchEnumsFromSchema(state.schema)

  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },
};

export const getters: GetterTree<LinesEquipmentState, RootState> = {
  totals : (state: LinesEquipmentState) => {
    return {
      sum: state.relatedEquipmentList.reduce((val: number, item: any) => {
        return val + (parseFloat(item.container_price) || 0)
      }, 0)
    }
  },
  addedEquipment: (state: LinesEquipmentState) => {
    return state.relatedEquipmentList.reduce((prev: any[], item: any) => {
      prev.push(item.equipment_id)
      return prev
    }, [])
  },
};

export const STORE_KEY = '$_lines_EQUIPMENT_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
